import classNames from 'classnames'

const BUTTON_ROUNDED_STYLES_LG =
  'h-[32px] rounded-full w-full sm:min-w-[120px] sm:w-auto mt-2 bg-surface hover:bg-surface-2 disabled:opacity-30 jost text-[0.9em] text-text border border-border'

export const BUTTON_ROUNDED_STYLES_SM =
  'h-[32px] rounded-full px-2 w-auto grow min-w-[120px] jost-light text-[0.9em] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-[8px]'

export const BUTTON_ROUNDED_STYLES_XS =
  'h-[27px] rounded-full px-2 w-auto grow min-w-[120px] jost-light text-[0.8em] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-[8px]'

interface IProps {
  form?: string
  type: 'button' | 'submit' | 'div'
  size?: 'xs' | 'sm' | 'lg'
  loading?: boolean
  text: string
  icon?: any
  className?: string
  iconContainerClassName?: string
  iconRight?: boolean
  callback?: (e: any) => void
}

export const ButtonRoundedSm = ({
  form,
  type,
  size = 'sm',
  loading,
  text,
  icon,
  className,
  iconContainerClassName,
  iconRight = false,
  callback
}: IProps) => {
  const getSizeStyles = () => {
    if (size === 'xs') return BUTTON_ROUNDED_STYLES_XS
    if (size === 'lg') return BUTTON_ROUNDED_STYLES_LG

    return BUTTON_ROUNDED_STYLES_SM
  }
  if (type === 'submit') {
    return (
      <button form={form} className={classNames(className, getSizeStyles())} type='submit' disabled={loading}>
        {icon && !iconRight && <span className={iconContainerClassName}>{icon}</span>}
        {text}
        {icon && iconRight && <span className={iconContainerClassName}>{icon}</span>}
      </button>
    )
  }

  if (type === 'button') {
    return (
      <button
        className={classNames(className, getSizeStyles())}
        type='button'
        disabled={loading}
        onClick={(e) => {
          if (callback) {
            callback(e)
          }
        }}
      >
        {icon && !iconRight && <span className={iconContainerClassName}>{icon}</span>}
        <div className={classNames(icon && !iconRight && 'text-right', !icon && 'text-center')}>{text}</div>
        {icon && iconRight && <span className={iconContainerClassName}>{icon}</span>}
      </button>
    )
  }

  return (
    <div className={classNames(className, getSizeStyles())}>
      {icon && !iconRight && <span className={iconContainerClassName}>{icon}</span>}
      {text}
      {icon && iconRight && <span className={iconContainerClassName}>{icon}</span>}
    </div>
  )
}
